import { ICustomerFullProfile } from '../interfaces/customer';
import { axiosAdmin } from './axios';
import { IBaseClientProfile } from '../interfaces/clientProfile';
import { IClientAdminSearchParams } from '../interfaces/clientAdminSearchParams';
import { IListResponse } from '../interfaces/listResponse';
import { IClientAdminSearch } from '../interfaces/clientAdminSearch';

export namespace ClientService {
  const baseUrl = '/clients';

  export function createClient(profile: IBaseClientProfile): Promise<ICustomerFullProfile> {
    return axiosAdmin.post<ICustomerFullProfile>(baseUrl, profile).then(({ data }) => data);
  }

  export function completeCustomer(customerId: number): Promise<ICustomerFullProfile> {
    return axiosAdmin.post<ICustomerFullProfile>(`${baseUrl}/${customerId}/complete`).then(({ data }) => data);
  }

  export function getList(params: IClientAdminSearchParams): Promise<IListResponse<IClientAdminSearch>> {
    return axiosAdmin.post<IListResponse<IClientAdminSearch>>(baseUrl + '/search', params).then(({ data }) => data);
  }

  export function getOneById(customerId: number): Promise<ICustomerFullProfile> {
    return axiosAdmin.get<ICustomerFullProfile>(`${baseUrl}/${customerId}`).then(({ data }) => data);
  }
}